import { z } from "zod";

import { MAX as MAX_DECIMALS, MIN as MIN_DECIMALS } from "../../components/widget-form/decimals/settings";

export const dashboardWidgetFormatDecimalPlacesSchema = z
	.union([
		z
			.string()
			.trim()
			.pipe(z.literal(""))
			.transform(() => undefined),
		z.coerce.number().min(MIN_DECIMALS).max(MAX_DECIMALS),
	])
	.optional();

export const dashboardWidgetFormatSchema = z.object({
	unit: z.string().trim().optional().catch(undefined),
	decimalPlaces: dashboardWidgetFormatDecimalPlacesSchema,
});

export type DashboardWidgetFormat = z.infer<typeof dashboardWidgetFormatSchema>;

export type DashboardWidgetFormatDecimalPlaces = z.infer<typeof dashboardWidgetFormatDecimalPlacesSchema>;
